import * as React from "react";
import { Container } from "react-bootstrap";
import { ReactNode } from "react";

interface PublicPageContainerProps {
    id?: string;
    children: ReactNode;
}

export function PublicPageContainer(props: PublicPageContainerProps) {
    const { children, id } = props;
    return (
        <section id={id} className="flex-grow-1">
            <Container className="my-5">{children}</Container>
        </section>
    );
}
